var balls = [];

var ball = function(){
    this.pos={};
}
ball.prototype.append=function(){
    this.pos.x=this.cliW*Math.random();
    this.pos.y=-this.cliH*Math.random();
    this.r= 1+Math.random()*1;
    this.alpha =0.4+Math.random()*0.2;
    this.speedA=0.0006+Math.random()*0.001;
    this.speed=0.2+Math.random();
    this.speedX=Math.random()>0.5?Math.random()*0.7:-Math.random()*0.7;
}
ball.prototype.update=function(){
    //if(this.alpha<0||this.pos.x<-this.cliW||this.pos.x>this.cliW||this.pos.y<-this.cliH)
    if(this.alpha<0||this.pos.x>this.cliW||this.pos.y>this.cliH)
    //if(this.alpha<0)
        this.append();
    this.alpha-=this.speedA;
    this.pos.y+=this.speed;
    this.pos.x-=this.speedX;
}
ball.prototype.draw=function(){
    var _this=this;
    _this.context.beginPath();
    _this.context.arc(_this.pos.x, _this.pos.y, _this.r, 0, 2 * Math.PI, false);
    _this.context.fillStyle = 'rgba(0,229,228,1)';
    _this.context.fill();
}
ball.prototype.gogogo=function(){
    this.update();
    this.draw();
}

var FlyBalls=function(outerDom,canvasId){
    var canvas=document.getElementById(canvasId);
    if(!canvas){
        canvas = document.createElement('canvas');
        canvas.setAttribute("id", canvasId);
        canvas.setAttribute("width", outerDom.clientWidth);
        canvas.setAttribute("height", outerDom.clientHeight);

        if(outerDom.style.position!=='relative' && outerDom.style.position!=='absolute' && outerDom.style.position!=='fixed'){
            outerDom.style.position='relative';//此处如果设置了，将会使得antd的menu-mask范围失效。所以调用的组件需要额外地再取消该设置
        }
        //步骤：遍历兄弟元素，如果兄弟元素无定位，设置relative，然后取最小的zIndex值，将canvas的zindex设为最小值-1
        for(var i=0;i<outerDom.childNodes.length;i++){
            let cd=outerDom.childNodes[i];
            if(!['relative','absolute','fixed'].includes(cd.style.position)){
                cd.style.position='relative';
                cd.style.zIndex='1';
            }
            else{
                //省略取最小的zindex，直接将canvas的zindex设为0
                if(!(parseInt(cd.style.zIndex)>0)){
                    cd.style.zIndex='1';
                }
            }
        }
        canvas.style.position='absolute';
        canvas.style.zIndex='0';
        canvas.style.top='0';
        canvas.style.left='0';
        outerDom.appendChild(canvas);
    }
    this.context=canvas.getContext('2d');
    this.isAnimate = false;
    this.len=canvas.width/20;
    this.cliW=canvas.width;
    this.cliH=canvas.height;
    this.isAnimate=false;
}
FlyBalls.prototype.Run=function(len){
    if(len===undefined){
        len=this.len;
    }
    var balls=[];
    for(var i=0;i<len;i++){
        var b=new ball();//新建小气泡
        b.context=this.context;
        b.len=this.len;
        b.cliW=this.cliW;
        b.cliH=this.cliH;
        b.append();
        balls.push(b);//把气泡放到balls数组里
    }
    this.balls=balls;
    var interBall = setInterval(function(){
        if(!this.isAnimate){
            this.context.clearRect(0,0,this.cliW,this.cliH);//把画布擦干净
            for(var i=0;i<this.balls.length;i++){
                this.balls[i].gogogo();//绘制所有小气泡
            }
        }
    }.bind(this),20);
}

export default FlyBalls;


